export default "__VITE_ASSET__BCxSR1N5__"